import { Component, inject, OnInit, signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { SafeUrl } from '@angular/platform-browser';
import { ProductsLookupService } from '../../../../services/product/lookup.service';
import { CategoryVTO } from '../../../../pages/admin-dashboard/categories/category.model';
import { LanguageService } from '../../../../services/language.service';
import { CategoryService } from '../../../../services/category/category.service';
import { ProductsFileMgt } from '../../../../services/product/file-management/products.file-mgt.service';
import { LookupResultSet } from '../../../../pages/admin-dashboard/admin-companies/admin-companies.model';

@Component({
  selector: 'app-categories-section',
  imports: [RouterLink],
  templateUrl: './categories-section.html',
  styleUrl: './categories-section.scss',
})
export class CategoriesSection implements OnInit {
  private lookupService = inject(ProductsLookupService);
  private CategoryService = inject(CategoryService);
  private router = inject(Router);
  private languageService = inject(LanguageService);
  private fileMgt = inject(ProductsFileMgt);
  categories?: LookupResultSet;
  errorMessage = signal<string>('');
  locale = signal<string>(this.languageService.getCurrentLocale());
  categoryImages = new Map<number, { url: SafeUrl; isImage: boolean }>();
  ngOnInit() {
    this.lookupService.getLookupCategories().subscribe({
      next: (res) => {
        this.categories = res;
        res.list.forEach((category: CategoryVTO) => {
          if (category.profileImageFid) {
            this.fileMgt.getImageUrl(category.profileImageFid).subscribe({
              next: (res) => {
                this.categoryImages.set(category.id, res);
              },
              error: () => {
                this.categoryImages.set(category.id, { url: '', isImage: false });
              },
            });
          }
        });
      },
      error: (err) => {
        console.error('Error fetching categories', err);
        this.errorMessage.set($localize`:@@categoriesSectionError:Failed to load categories. Please try again later.`);
      },
    });
  }

  viewCategory(category: CategoryVTO) {
    this.router.navigate(['/user/products'], {
      queryParams: {
        categoryId: category.id,
        categoryTitleEn: category.titleEn,
        categoryTitleAr: category.titleAr,
      },
    });
  }
}
